'use client';

import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';

export default function ClientModuleWrapper({ exportName, componentType, dsmProps }) {
  const DynamicDSMModule = useMemo(() => {
    if (!exportName) return null;
    return dynamic(() => import('@kohler-dsm-library/kohler-modules').then((m) => m[exportName]), {
      ssr: false,
    });
  }, [exportName]);

  if (!DynamicDSMModule) {
    console.warn(
      `ClientModuleWrapper: Unable to resolve dynamic component for export "${exportName}" (${componentType})`,
    );
    return null;
  }

  try {
    return <DynamicDSMModule {...dsmProps} />;
  } catch (error) {
    console.error(
      `ClientModuleWrapper: Render error for ${componentType}/${exportName}:`,
      error?.message,
    );
    return null;
  }
}
